export interface IGetPaymentTermDto {
    code: string
    description: string
}

export default class PaymentTerm {
    code: string
    description: string

    constructor(dto: IGetPaymentTermDto) {
        this.code = dto.code
        this.description = dto.description
    }

    print() {
        return `${this.description} (${this.code})`
    }
}
